// removed by extract-text-webpack-plugin
module.exports = {"searchContentSection":"G4MlG"};